module.exports = __webpack_public_path__ + "static/img/1041.c2b2d2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1041.jpg
// module id = 223
// module chunks = 0